import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { LoggerIcon } from '@app/modules/logger/LoggerIcon';
import { theme } from '@mi-front/ui';
import { useStatusViewContext } from '../../../context/StatusViewContext';
import { StatusAvatarYoutubeBadge } from './StatusAvatarYoutubeBadge';
import { Station } from '@app/core/types/stations';

interface Props {
  readonly station: Station;
  readonly isOnline: boolean;
}

const Wrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'compact',
})<{ compact: boolean }>`
  border: 2px solid;
  border-radius: 50%;
  height: ${(p) => (p.compact ? '2rem' : '3rem')};
  width: ${(p) => (p.compact ? '2rem' : '3rem')};

  > svg {
    margin: ${(p) => (p.compact ? '4px' : '8px')};
    font-size: ${(p) => (p.compact ? '1.25rem' : '1.75rem')};
  }

  img {
    margin: ${(p) => (p.compact ? '0px' : '2px')};
    height: ${(p) => (p.compact ? '1.75rem' : '2.5rem')};
    width: ${(p) => (p.compact ? '1.75rem' : '2.5rem')};
    border-radius: 50%;
  }
`;

export function StatusAvatar(p: Props) {
  const { station, isOnline } = p;
  const { compact } = useStatusViewContext();

  return (
    <Box sx={{ position: 'relative', flexShrink: 0 }}>
      <Wrapper
        compact={compact}
        style={{
          borderColor: isOnline ? theme.green : theme.pink,
          color: isOnline ? theme.green : theme.pink,
        }}
      >
        {station.logoUrl ? (
          <img src={station.logoUrl} alt={`${station.name} logo`} />
        ) : (
          <LoggerIcon />
        )}
      </Wrapper>
      <StatusAvatarYoutubeBadge station={station} compact={compact} />
    </Box>
  );
}
